<nav
  id="navtabs"
  class="card md-tabs-1 md-card-tabs-1 navbar navbar-light bg-faded"
>
  <ul class="text-center">
    <li class="nav-item">
      <a
        class="nav-link"
        [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/community', community.name]"
      >
        <i class="icofont icofont-bag-alt"></i>
        <span>Latest Discussions</span>
      </a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/community', community.name, 'trending']"
      >
        <i class="icofont icofont-fire-burn"></i>
        <span>Trending Discussions</span>
      </a>
    </li>
  </ul>
</nav>
